'use client'

import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { fetchConstants } from '@/lib/redux/constantsSlice'

export default function ConstantsLoader() {
  const dispatch = useDispatch()
  const { data, status } = useSelector((state: any) => state.constants)

  useEffect(() => {
    if ((!data || data.length === 0) && status !== 'loading') {
      dispatch(fetchConstants() as any)
    }
  }, [data, status, dispatch])

  return null
}
